module.exports = require("npm:Base64@0.2.1/base64.js");